import {
  SET_SUBMISSION_MODAL,
  FAST_LOAN_SUBMISSION,
  FAST_LOAN_SUBMIT_FORM,
  SET_TENOR_DATA,
  SET_PROVINCES,
  SET_CITIES,
} from './constants';

function setSubmissionModal(value) {
  return {
    type: SET_SUBMISSION_MODAL,
    payload: { submissionModal: value },
  };
}

function submissionCheck(history) {
  return { type: FAST_LOAN_SUBMISSION, payload: { history } };
}

function submitForm(history, body) {
  return { type: FAST_LOAN_SUBMIT_FORM, payload: { history, body } };
}

function setTenorData(payload) {
  return { type: SET_TENOR_DATA, payload };
}

function setProvinces(payload) {
  return { type: SET_PROVINCES, payload };
}

function setCities(payload) {
  return { type: SET_CITIES, payload };
}

export const fastLoanAction = {
  setSubmissionModal,
  submissionCheck,
  submitForm,
  setTenorData,
  setProvinces,
  setCities,
};
